import { CustomFieldTypeIcon } from 'v5/patterns/widgets/customFieldTypeIcons';
import { CustomFieldDefinition } from '__types__';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createFallbackFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterStringConfig {
  return {
    label: customFieldDef.name,
    icon: <CustomFieldTypeIcon type={customFieldDef.data_type} />,
    type: 'string' as const,
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: `Search by ${customFieldDef.name.toLowerCase()}`
    }
  };
}
